import { assertNotEmpty } from '@festina-life/core'
import { FPlusCodeContainer } from '@festina-life/fplus'
import { useNavigate } from 'react-router'

import { useTemplateContext } from '../../context/templateContext'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useOperationsContext } from '../../workspace/operationsContext'
import { InlineTextEditor } from '../inlineTextEditor/InlineTextEditor'

type Props = {
  isExpanded: boolean
}

export const TemplateVersionName = ({ isExpanded }: Props) => {
  const { templateVersion, isDraftTemplate } = useTemplateContext()
  const { workspaceKey } = useOperationsContext()
  const { applicationTemplates } = useApplicationViewOperationsContext()
  const navigate = useNavigate()
  const name = templateVersion?.versionInfo.identifier
  const { server, branch } = useNavigationParams()

  assertNotEmpty(name)

  const indexedTemplateCreateOperations = templateVersion
    ? applicationTemplates?.get(name)
    : undefined

  const areOtherVersionsPresent =
    !!indexedTemplateCreateOperations &&
    indexedTemplateCreateOperations.operations.length > 1

  const isNameEditable =
    isExpanded && isDraftTemplate && !areOtherVersionsPresent

  const handleSaveChanges = async (nextValue: string) => {
    assertNotEmpty(templateVersion)

    await templateVersion?.updateTemplate({
      ...templateVersion,
      versionInfo: {
        ...templateVersion.versionInfo,
        identifier: nextValue,
      },
    })

    await navigate(
      configurationItem({
        server,
        branch,
        type: 'template',
        itemId: nextValue,
        workspaceName: workspaceKey?.name,
        layer: templateVersion.layer,
        block: templateVersion.block,
      }),
    )
  }

  return (
    <FPlusCodeContainer className="group relative">
      {isNameEditable ? (
        <InlineTextEditor initialValue={name} onSave={handleSaveChanges} />
      ) : (
        <div>{name}</div>
      )}
    </FPlusCodeContainer>
  )
}
